import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/wheel/img_border_neon1.png")